export default {
  faqTitle: 'Türkiye Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Türkiye Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'TurkiyeSigortaCompulsoryTraffic'
      },
      {
        id: 2,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'TurkiyeSigortaMotorInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
        path: 'TurkiyeSigortaDaskInsurance'
      },
      {
        id: 4,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'TurkiyeSigortaHomeInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building  fa-2x mr-2',
        path: 'TurkiyeSigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'TurkiyeSigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
        path: 'TurkiyeSigortaTransportation'
      },
      {
        id: 8,
        title: 'ÖZEL SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-heartbeat fa-2x mr-2',
        path: 'TurkiyeSigortaHealthInsurance'
      },

      {
        id: 9,
        title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
        path: 'TurkiyeSigortaComplementaryHealth'
      },
      {
        id: 10,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'TurkiyeSigortaTravelInsurance'
      }
    ]
  },
  introContent: {
    title: 'Türkiye Sigorta Hakkında',
    content: [
      {
        paragraph:
          '“Gücü, adında” sloganı ile sigortalılarına hizmet veren Türkiye Sigorta kamu şirketlerinin birleşimi ile hizmet vermeye devam etmektedir.'
      },
      {
        paragraph:
          'Türkiye Sigorta 6 köklü şirketin birleşimi ile oluşmuştur. Şirketler arasında; Ziraat Sigorta, Halk Sigorta, Güneş Sigorta, Ziraat Emeklilik, Halk Emeklilik ve Vakıf Emeklilik şirketi yer almaktadır. Bundan sonra hizmet vermeye Türkiye Sigorta ve Türkiye Hayat Emeklilik olarak devam eden şirket sigortalılarına kaliteli hizmet verme amacıyla ve global teknoloji şirketi olma vizyonu ile ilerlemektedir.'
      },
      {
        paragraph:
          "Türkiye Sigorta ana hissedarı, TVF Finansal Yatırımlar Anonim Şirketi'dir."
      },
      {
        paragraph:
          'Türkiye Sigorta; çevik ve yenilikçi anlayışı ile hizmet sunmaya odaklanırken, isminden aldığı güçle, her şartta sigortalılarının yanındadır. '
      },
      {
        paragraph:
          'Türkiye’nin en önemli sigorta şirketlerinden birisi olan Türkiye Sigorta’nın ürünlerine online 7/24 sitemizden ulaşabilirsiniz.  '
      }
    ]
  },
  questions: [
    {
      title: 'Türkiye Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın geniş kapsamlı sunmuş olduğu ürünler aşağıdaki gibidir.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Araç Sigortaları: </u></em></strong>',
          subList: [
            'Genişletilmiş Kasko ',
            'Dost Kasko ',
            'Muafiyetli Kasko ',
            'Fiat Kasko ',
            'Trafik Sigortası'
          ]
        },
        {
          paragraph: '<strong><em><u>Konut Sigortaları: </u></em></strong>',
          subList: [
            'Konut Ekstra Paket Sigortası ',
            'Konut Paket Sigortası ',
            'Pratik Ev Sigortası',
            'Site Ortak Alan Sigortası ',
            'Zorunlu Deprem Sigortası (DASK)'
          ]
        },
        {
          paragraph: '<strong><em><u>Sağlık Sigortaları: </u></em></strong>',
          subList: [
            'Okyanus Limitsiz Sağlık Sigortası',
            'Okyanus Limitli Sağlık Sigortası',
            'Tamamlayıcı Sağlık Sigortası',
            'Okyanus Ekstra Sağlık Sigortası',
            'Okyanus Avantaj Sağlık Sigortası'
          ]
        },
        {
          paragraph: '<strong><em><u>Seyahat Sigortaları: </u></em></strong>',
          subList: [
            'Turist Koruma ve Destek Sigortası ',
            'Yatarak Tedavi ',
            'Seyahat Sağlık Sigortası ',
            'Yabancı Uyruklular Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Kurumsal/Ticari Sigortaları: </u></em></strong>',
          subList: [
            'İşyeri Ekstra Sigortası',
            'Kapsamlı İşyeri Sigortası',
            'Eczane Paket Sigortası',
            'Otel Paket Sigortası ',
            'Akaryakıt Paket Sigortası',
            'Oto Plaza Paket Sigortası'
          ]
        },
        {
          paragraph: '<strong><em><u>Diğer Sigortalar: </u></em></strong>',
          subList: [
            'Emtea Sigortası ',
            'Tekne Sigortası ',
            'İnşaat Sigortası ',
            'Ferdi Kaza Sigortası'
          ]
        },
        {
          paragraph:
            '***Ürün çeşitliliği fazla olan Türkiye Sigorta’nın poliçe fiyatlarını değerlendirmek için AloKasko uzmanlarından teklif talebinde bulunabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası poliçesi trafikte üçüncü şahıslara verilen zararları karşılayan sigorta türüdür. Trafik sigortası, motorlu aracın kullanımı sırasında karşı sürücüye ve aracına verdiği zararları genel şartlar kapsamında güvence altına alır.',
          subList: null
        },
        {
          paragraph:
            'Yaptırılması kanunen zorunlu olan trafik sigortası poliçenizi Türkiye Sigorta güvencesinde yaptırarak, üçüncü şahıslara karşı vereceğiniz zarar ve hasarları güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortası, 1 yıllık yaptırılan sigorta çeşididir. Türkiye Araç Kasko Sigortası sunmuş olduğu teminatlar kapsamında kendi aracınızı olası hasar durumlarına karşı güvence altına alarak, geniş kapsamlı hizmetler sunar.',
          subList: null
        },
        {
          paragraph:
            '<strong><u>Genişletilmiş Kasko:</u></strong> İsminden de anlaşılacağı üzere geniş kapsamlı kasko poliçesidir. Güvence altına alınan durumlar arasında; ',
          subList: [
            'Anahtar kaybı neticesinde aracın çalınması',
            'Anahtar kaybı neticesinde kilit mekanizmasının değiştirilmesi',
            'Aracın yanması',
            'Çalınma',
            'Çarpma ve çarpışma',
            'Deprem, toprak kayması, fırtına, dolu, yıldırım veya yanardağ püskürmesi nedeniyle meydana gelen zararlar',
            'Eskime payı',
            'Ferdi kaza acil yardım teminatı',
            'Ferdi kaza koltuk',
            'Ferdi kaza koltuk deprem teminatı',
            'Ferdi kaza koltuk ölüm ve sürekli sakatlık teminatı',
            'Grev, lokavt, halk hareketleri, terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İhtiyari mali sorumluluk manevi tazminat talepleri',
            'İş durması',
            'Kasa teminatı',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Mini onarım',
            'Motorlu araca bağlı hukuksal koruma',
            'Özel eşya teminatı',
            'Patlayıcı ve parlayıcı madde taşınması',
            'Sel ve su baskını',
            'Ses ve görüntü cihazları',
            'Sürücü hukuksal koruma',
            'Taşınan yük',
            'Taşıtta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar',
            'Yanlış akaryakıt dolumu',
            'Yetkili olmayan kişilere çektirme, çekme',
            'Yurt dışında meydana gelen zararlar yer almaktadır.'
          ]
        },
        {
          paragraph:
            'Tüm risklere karşı aracınızı güvence altına almak isterseniz genişletilmiş kaskoyu tercih edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Bunun dışında; Dost Kasko - Muafiyetli Kasko - Fiat Kasko paketleri de bulunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Dost Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Dost Kasko Sigortasını 2 yaş ve üzeri olan otomobil - hafif ticari sınıfında yer alan araçlar yaptırabilir. ',
          subList: null
        },
        {
          paragraph:
            'Dost kasko sigortasına sahip olan araç sürücüleri yaygın kullanılan servis ağından hizmet alarak, orijinal yedek parça ile hasar onarımlarını yaptırır. Güvence altına almış olduğu teminatlarda yine genişletilmiş kasko gibi kapsamlıdır.',
          subList: [
            'Sunulan hizmetler arasında; araç çekilmesi – yol yardım hizmetleri – lastik ve kilit değişimi – benzin bitmesi durumunda çekim hizmeti - profesyonel sürücü hizmeti gibi birçok hizmet bulunur.',
            'Üstelik ferdi kaza teminatını da poliçe kapsamına eklenebilir, olası durumlardan yararlanabilirsiniz. Ferdi kaza teminatı, kaza durumunda meydana gelen sağlık sorunlarındaki tedavi süreçleri içindir.',
            'Dost kasko poliçesinde mini onarım teminatı da bulunur.',
            'Yılda en fazla 2 defa ikame araç alma hakkınızda bulunur.'
          ]
        },
        {
          paragraph:
            'Daha kapsamlı bilgi almak için başvuru formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Muafiyetli Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortasına fazla bütçe ayırmak istemeyenlerin yararlanabileceği bir poliçedir.',
          subList: null
        },
        {
          paragraph:
            'Her durumda kasko sigortasını bozdurmak istemeyen araç sahipleri, muafiyetli kasko sigortası yaptırarak 2.500 TL üzerindeki hasarları güvence altına alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Fiat Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Genişletilmiş Fiat Kasko Sigortası, FIAT ve TOFAŞ FIAT araçları güvence altına almaktadır.',
          subList: null
        },
        {
          paragraph:
            'FIAT aracınız varsa, Türkiye Sigorta’nın size özel hazırlamış olduğu ayrıcalıklı kasko poliçesinden yararlanabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Teminat durumları hakkında bilgi almak için başvuru formunu doldurabilir veya <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarını <strong><em><u>0216 371 67 77</u></em></strong> hattından arayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası, tüm ev sahiplerinin yaptırması zorunlu olan sigorta çeşididir. Hem kendimizi hem sevdiklerimizi hem de konutumuzu güvence altına almamız için deprem sigortasını her yıl yenilememiz gerekir.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>DASK – Zorunlu Deprem Sigortası;</u></em></strong> sigortalı binayı depreme ve depremin sebep olabileceği yangın, infilak, yer kayması, tsunami olaylarına karşı güvence altına alır. Bu durumlar sonucunda sigortalı binada oluşan zarar ve hasarlar, deprem sigortası limitleri dâhilinde Türkiye Sigorta tarafından karşılanır.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu deprem sigortası poliçeleri 1 yıllık yapılır ve her sene düzenli olarak yenilenir. Türkiye Sigorta kapsamında konutunuzu güvence altına almak için fiyat teklifi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Evinizi ve eşyalarınızı Türkiye Sigorta güvencesinde koruma altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası paketleri arasında değerlendirme yapabileceğiniz 4 farklı poliçe vardır.',
          subList: null
        },
        {
          paragraph: 'Bunlar:',
          subList: [
            'Konut Ekstra Paket Sigortası,',
            'Konut Paket Sigortası,',
            'Pratik Ev Sigortası,',
            'Site Ortak Alan Sigortasıdır.'
          ]
        },
        {
          paragraph:
            'Teminat seçeneklerini ve avantajlarını karşılaştırarak en doğru poliçeyi tercih edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '** Toplu yaşam alanlarınızı kapsayan ve sitenin sorumluluklarını güvence altına almak için Site Ortak Alan Sigortasını tercih edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta İşyeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta işyeri sahiplerini de kapsamlı bir şekilde düşünerek 6 farklı poliçe hazırlamıştır.',
          subList: null
        },
        {
          paragraph:
            'Değer verdiğiniz ve zamanınızın büyük bir kısmının geçtiği işyerinizi Türkiye Sigorta güvencesinde sigortalayabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İşyeri sigortası; deprem, yangın, grev, terör, hırsızlık, cam kırılması, ferdi kaza, iş durması, kar kaybı, işveren mali mesuliyet, elektronik cihaz teminatı, makine kırılması, elektrik hasarları gibi birçok teminat ile güvence sunar.',
          subList: null
        },
        {
          paragraph:
            'Ekstra işyeri yardım hizmetleri ile poliçe kapsamını ve avantajlarını da genişletir.',
          subList: null
        },
        {
          paragraph:
            '** Eczane Paket Sigortası - Otel Paket Sigortası - Akaryakıt Paket Sigortası - Oto Plaza Paket Sigortası poliçelerini de değerlendirebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası, sigortalının hayati risklerin güvence altına alır.',
          subList: null
        },
        {
          paragraph:
            'Türkiye Sigorta ferdi kaza sigortasını 16 - 65 yaş arasında olan adaylar yaptırabilir. Ferdi kaza sigortaları genel olarak yıllık yapılan sigorta poliçeleridir. Fakat ihtiyaç doğrultusunda poliçe süresini belirleyebilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Teminatlar arasında:',
          subList: [
            'Kaza sonucu vefat teminatı,',
            'Kaza sonucu tam ve kısmi maluliyet teminatı,',
            'Kaza sonucu tedavi masrafları teminatı,',
            'Gündelik iş görmezlik teminatı bulunur.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Taşıma sırasında oluşabilecek riskleri güvence altına alan Türkiye Sigorta Emtea Sigorta ile yolda meydana gelebilecek hasar ve zararları sigorta kapsamına dahil edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Emtea Sigorta ile hem yurt içinde hem de yurt dışında her çeşit nakil aracıyla taşınan yükler güvence altına alınmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Emtea Nakliyat Sigortaları 3 Alternatifli Teminat Sunmaktadır:',
          subList: ['Geniş Teminat', 'Dar Teminat', 'Tam Ziya Teminatı']
        },
        {
          paragraph:
            '**Teminat kapsamlarını ve nakliyat sigortası fiyatlarını değerlendirmek için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sağlığını düşünen, sağlığını güvence altına almak isteyen kişiler için Türkiye Sigorta 5 farklı poliçe sunmaktadır. Bunlar;',
          subList: [
            'Okyanus Limitsiz Sağlık Sigortası,',
            'Okyanus Limitli Sağlık Sigortası,',
            'Tamamlayıcı Sağlık Sigortası',
            'Okyanus Ekstra Sağlık Sigortası',
            'Okyanus Avantaj Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            'Sağlık ihtiyaçlarınızı göz önünde bulundurarak; özel sağlık sigortası veya tamamlayıcı sağlık sigortası satın alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortaları arasında; Okyanus Limitsiz Sağlık Sigortası - Okyanus Limitli Sağlık Sigortası yer alır. Limitli veya limitsiz sağlık sigortalarından seçim yapabilirsiniz. Sağlık sigortası yaptırmayı düşünüyorsanız, sağlık uzmanlarımızı arayabilir <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan veya başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası ile özel hastanelerden hizmet alabilir ve sağlık harcamalarına fark ücreti ödemezsiniz.',
          subList: null
        },
        {
          paragraph:
            'Yatarak ve Yatarak + Ayakta Tedavi planlarıyla birlikte poliçenize ekleyebileceğiniz <strong><em><u>Doğum Teminatı</u></em></strong> da sunulmaktadır. Doğum teminatı için bekleme süresi 1 yıldır.',
          subList: null
        },
        {
          paragraph:
            'Türkiye Sigorta sağlık sigortası müşterilerine ekstra aile indirimi de sunmaktadır. Sunulan aile indiriminden yararlanabilmek için poliçe kapsamında en az 2 aile üyesi olmalıdır. Aile sağlık sigortası satın alarak primlerinizde %10 indirim hakkı kazanabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası fiyatlarını değerlendirmek isteyen müşterilerimiz, internete özel online fiyatlarımız için teklif formunu doldurabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Tekne Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Tekne Yat Sigortaları kapsamında hazırlanmış olan bu ürün, ticari amaçla yük taşıyan teknelerde oluşabilecek risk durumlarını güvence altını alır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Sigorta kapsamında;</u></em></strong> fırtına sonucunda oluşabilecek zararlar, çarpma – batma – çatışma sonucunda oluşabilecek durumlar, deprem, yangın, yıldırım, volkanik patlama sonucundaki zararlar gibi birçok riske karşı güvence sağlar.',
          subList: null
        },
        {
          paragraph:
            'Üstelik ek teminat grubundan birçok teminatını da poliçenize ekleyebilir ve güvence alanını genişletebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Turist koruma ve destek sigortası - yatarak tedavi sigortası kapsamında Covid-19 teminatı yer alır. Coronavirüse karşı hazırlanmış bu poliçe ile tatilinizin tadını çıkabilirsiniz. Bu poliçeyi tatil süreniz boyunca yaptırabilirsiniz. Seyahat süresine göre farklılık gösteren poliçe maksimum 30 güne kadar yapılmaktadır. Covid-19 Turist Koruma ve Destek Sigortası’nı 0-65 yaş arasında olan kişiler yaptırabilir ve bekleme süresi bulunmaz.',
          subList: null
        },
        {
          paragraph:
            'Seyahat sağlık sigortası poliçelerinin yanı sıra Yabancı Uyruklu Sağlık Sigortası da bulunur. <strong><em><u>Yabancı Uyruklu Sağlık Sigortası;</u></em></strong> yabancıların ülkemizde ikamet edebilmesi için yaptırması gereken sigorta çeşididir. Türkiye’de bulunulan süre içerisinde sağlığınızı da güvence altına alır. Yabancı sağlık sigortası poliçe tarihinden 1 yıl geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta poliçe sorgulaması yapmak için sigorta şirketinin resmi web sitesini ziyaret edebilirsiniz. “<strong><em><u>Online İşlemler</u></em></strong>” sayfasına giriş yaparak sorgulama adımlarını takip edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Hasar ihbarı ve hasar dosya sorgulaması yapmak için Türkiye Sigorta resmi web sitesini ziyaret edebilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com ekibinden yaptırmış olduğunuz sigorta poliçeniz kapsamında bir hasar meydana gelmişse sigorta danışmanıza <strong><em><u>0216 371 67 77</u></em></strong> iletişim hattını arayarak bilgi verebilir, dosyanız açıldıysa hasar dosya sorgulamasını yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta poliçe fiyatlarını değerlendirmek için <strong><em><u>alokasko.com</u></em></strong> uzmanlarından fiyat alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Online fiyat teklifi alarak karşılaştırma yapabilir, en doğru poliçeyi satın alabilirsiniz. Takıldığınız tüm sorular için sigorta uzmanlarımız yanınızda!',
          subList: null
        }
      ]
    }
  ]
}
